import axios from 'axios'
import auth from 'utils/auth'

import { API_ENDPOINT } from 'config'

class PoxAPI {

	constructor () {
		this.api = axios.create({
		  baseURL: API_ENDPOINT,
		  headers: {
		    Authorization: {
		      toString () {
		        return `Bearer ${auth.getToken()}`
		      }
		    }
		  }
		})
	}

	async fetchRevive ({startDate, endDate, publisherIds}) {
		startDate = startDate.format('YYYY-MM-DD')
		endDate = endDate.format('YYYY-MM-DD')
		return this.api.get(`/revive/getStats/${startDate}/${endDate}?publisherIds=${publisherIds}`)
	}

}

const pox_api = new PoxAPI()

export default pox_api


// WEBPACK FOOTER //
// ./src/utils/api.js